module.exports = __webpack_public_path__ + "img/banner-principal@2x.a63ccf88.png";